import { IImageConverter } from './image-converter.interface';

export class ImageConverter implements IImageConverter {
  /**
   * Преобразовать изображение.
   *
   * @param image - Исходное изображение в виде Blob.
   * @returns Преобразованное изображение в виде Blob.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async convert(image: Blob): Promise<Blob> {
    throw new Error('Неподдерживаемый тип изображения');
  }
}
